import { render, staticRenderFns } from "./KBKLimitsAutonomousUpdateWidget.view.vue?vue&type=template&id=3c76321c&"
import script from "./KBKLimitsAutonomousUpdateWidget.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitsAutonomousUpdateWidget.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c76321c')) {
      api.createRecord('3c76321c', component.options)
    } else {
      api.reload('3c76321c', component.options)
    }
    module.hot.accept("./KBKLimitsAutonomousUpdateWidget.view.vue?vue&type=template&id=3c76321c&", function () {
      api.rerender('3c76321c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/kbk-limits/update/KBKLimitsAutonomousUpdateWidget.view.vue"
export default component.exports